import Reparto from './repartoejecucion.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/repartoejecucion/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('repartoejecucion', ['ADMIN', 'INSPECTOR'], Reparto),
        keepAlive: true
    },
    {
        path: '/repartoejecucion/filter',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('repartoejecucion', ['ADMIN', 'INSPECTOR'], Reparto, { searchOnInit: true }),
        keepAlive: false
    }
];
export default routes;